import ProductShort from './ProductShort.jsx';

export default ProductShort;


// WEBPACK FOOTER //
// ./src/components/ProductShort/index.jsx